import * as React from "react";

const CustomExpandIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            role="presentation"
        >
            <path
                stroke="#545454"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 1h6v6M7 19H1v-6M19 1l-7 7M1 19l7-7"
            ></path>
        </svg>
    );
};

export default React.memo(CustomExpandIcon);
